module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/25eac09980011373fca550b4f97acc07.png";